import { Component, effect, viewChild } from '@angular/core';
import { SimpleDialog, Button } from 'excellence-ui';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserSettingsForm } from '../../../user/components/user-settings-form/user-settings-form';
import { environment } from '../../../../../environments/environment';
import {
  areSettingsInitialized,
  writeDefaultSettingsToStorage,
} from '../../helper/demo-user-settings';

/**
 * Self opening cookie banner for the demo mode
 *
 * Used to collect consents, since user creation is skipped in the demo
 * and consents are stored in the browsers storage instead.
 */
@Component({
  selector: 'app-demo-cookie-banner-dialog',
  templateUrl: './demo-cookie-banner-dialog.html',
  imports: [SimpleDialog, UserSettingsForm, Button, TranslocoPipe],
})
export class DemoCookieBannerDialog {
  protected readonly links = environment.links;
  protected readonly registerLumoUrl = environment.demo.registerLumoUrl;
  private simpleDialog = viewChild(SimpleDialog);

  constructor() {
    // open when the page loads & it was never accepted before
    if (!areSettingsInitialized()) {
      this.init();
    }
  }

  private init() {
    effect(() => {
      const dialog = this.simpleDialog();
      if (!dialog) {
        return;
      }
      dialog.showModal();
    });
  }

  protected onClickDecline() {
    window.location.href = environment.links.lumo;
  }

  protected onClickConfirm() {
    if (!areSettingsInitialized()) {
      writeDefaultSettingsToStorage();
    }
    this.simpleDialog()?.close();
  }
}
